<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    size="lg"
    no-close-on-backdrop
    title="Reservation Form"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="mb-0 title">Reservation Form</h5>
        <!-- <div class="d-flex gap-2 align-items-center">
          <span class="date">17/02/2025 16:00:00</span>
          <span
            class="bg-success rounded-circle bar-status"
            style="width: 10px; height: 10px"
          ></span>
          <span class="info-status">online: <span>Ruth</span></span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="closeModal">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BTabs content-class="mt-3" align="center" justified>
      <BTab title="Reservation" active>
        <BForm>
          <div class="form-group position-relative">
            <BFormInput
              v-model="searchQuery"
              @focus="isTyped = true"
              @blur="handleBlur"
              placeholder="Search guest name"
              autocomplete="off"
            >
            </BFormInput>

            <BListGroup
              v-if="
                searchQuery.length > 0 &&
                filteredGuestItems.length > 0 &&
                isTyped
              "
              class="position-absolute w-100 border rounded-lg"
              style="z-index: 10; cursor: pointer"
            >
              <BListGroupItem
                v-for="(guest, index) in filteredGuestItems"
                :key="index"
                @mousedown.prevent="selectGuest(guest)"
                :value="guest.uuid"
                class="p-2 border-0"
              >
                {{ guest.fullname }}
              </BListGroupItem>
            </BListGroup>
            <span
              v-if="searchQuery.length && filteredGuestItems.length === 0"
              class="text-muted mt-2"
            >
              Guest not found <router-link to="/guest">Add guest</router-link>
            </span>
          </div>
          <BRow>
            <BCol>
              <div class="form-group">
                <label for="">Check-in Date</label>
                <BFormInput type="date" v-model="reservationForm.start">
                </BFormInput>
              </div>
            </BCol>
            <BCol>
              <div class="form-group">
                <label for="">Check-out Date</label>
                <BFormInput type="date" v-model="reservationForm.end">
                </BFormInput>
              </div>
            </BCol>
          </BRow>
          <div class="form-group">
            <BFormSelect
              v-model="selectedRoomCategory"
              :options="roomCategories"
              text-field="name"
              value-field="name"
              class=""
              :disabled="!reservationForm.start || !reservationForm.end"
            >
              <template #first>
                <BFormSelectOption :value="null" disabled
                  >Select Type Room</BFormSelectOption
                >
              </template>
            </BFormSelect>
          </div>
          <div v-if="selectedRoomCategory" class="form-group">
            <BFormSelect
              v-model="reservationForm.room_uuid"
              :options="filteredRoomItems"
              text-field="code"
              value-field="uuid"
              @change="handleSelectedRoom($event.target.value)"
              class=""
              :disabled="!reservationForm.start && !reservationForm.end"
            >
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Room Number
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>

          <!--  pemilihan source booking -->
          <div class="form-group">
            <!-- <BFormSelect
              v-model="selectedSourceType"
              :options="sourceTypes"
              text-field="name"
              value-field="type"
              class=""
              @change="
                selectedSourceType === 'walk_in' ||
                selectedSourceType === 'direct_booking'
                  ? (reservationForm.source_uuid = sources.find(
                      (s) => s.type == selectedSourceType
                    ).uuid)
                  : ''
              "
            > -->
            <BFormSelect
              v-model="selectedSourceType"
              :options="sourceTypes"
              text-field="name"
              value-field="type"
              class=""
            >
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Source Type
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <!-- Pilih Source Detail (hanya untuk type dengan banyak pilihan) -->
          <div
            class="form-group"
            v-if="
              ['booking_online', 'agent'].includes(selectedSourceType)"
          >
            <!-- <BFormSelect
              v-model="reservationForm.source_uuid"
              :options="filteredSourceItems"
              text-field="name"
              value-field="uuid"
              class=""
            > -->
            <BFormSelect
              v-model="reservationForm.source_uuid"
              :options="filteredSourceItems"
              text-field="name"
              value-field="uuid"
            >
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  {{
                    selectedSourceType === "booking_online"
                      ? "Select Platform"
                      : "Select Agent"
                  }}
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <!-- Booking Number hanya untuk booking_online -->

          <!-- //**versi lama */ -->
          <!-- <div
            class="form-group"
            v-if="selectedSourceType === 'booking_online'"
          > -->
          <div
            class="form-group"
            v-if="selectedSourceType === 'booking_online'"
          >
            <BFormInput
              type="text"
              v-model="reservationForm.booking_number"
              placeholder="Booking Confirmation Number (optional)"
            ></BFormInput>
          </div>
        </BForm>
      </BTab>
      <!--  tab extracharge -->
      <BTab title="Extra Charge">
        <BForm>
          <BRow v-for="(ext, index) in extraChargeItems" :key="index" class="mb-3 align-items-center">
            <BCol md="4">
              <div class="form-group mb-0">
                <label v-if="index === 0" class="small text-muted mb-1">Category</label>
                <BFormSelect
                  v-model="ext.selectedExtraChargeCategory"
                  :options="extraChargeCategories"
                  text-field="name"
                  value-field="uuid"
                  @change="
                    handleExtraChargeCategory($event.target.value, index)
                  "
                  class=""
                >
                  <template #first>
                    <BFormSelectOption :value="null" disabled>
                      Select Category
                    </BFormSelectOption>
                  </template>
                </BFormSelect>
              </div>
            </BCol>
            <BCol md="3">
              <div class="form-group mb-0">
                <label v-if="index === 0" class="small text-muted mb-1">Item</label>
                <BFormSelect
                  v-model="ext.selectedExtraChargeUuid"
                  :options="ext.extracharges"
                  text-field="name"
                  value-field="uuid"
                  @change="handleExtraCharge($event.target.value, index)"
                  class=""
                >
                  <template #first>
                    <BFormSelectOption :value="null" disabled>
                      Select Item
                    </BFormSelectOption>
                  </template>
                </BFormSelect>
              </div>
            </BCol>
            <BCol md="2">
              <div class="form-group mb-0">
                <label v-if="index === 0" class="small text-muted mb-1">Qty</label>
                <BInputGroup>
                  <BButton
                    variant="light"
                    class="border px-2"
                    @click="decreaseQuantity(index)"
                    ><i class="fas fa-minus"></i
                  ></BButton>
                  <BFormInput
                    type="number"
                    v-model="ext.quantity"
                    min="0"
                    class="text-center px-1"
                  ></BFormInput>
                  <BButton
                    variant="light"
                    class="border px-2"
                    @click="increaseQuantity(index)"
                    ><i class="fas fa-plus"></i
                  ></BButton>
                </BInputGroup>
              </div>
            </BCol>
            <BCol md="3">
              <div class="form-group mb-0">
                <label v-if="index === 0" class="small text-muted mb-1">Price (IDR)</label>
                <BFormInput
                  type="number"
                  v-model.number="ext.price"
                  min="0"
                  placeholder="0"
                ></BFormInput>
              </div>
            </BCol>
          </BRow>
          <BButton variant="danger" @click="deleteItemExtracharge" class="mr-2"
            ><i class="fas fa-minus"></i
          ></BButton>
          <BButton variant="success" @click="addItemExtraCharge"
            ><i class="fas fa-plus"></i
          ></BButton>
          <div class="d-flex justify-content-end align-items-center">
            <p class="m-0">
              Total Extra Charge : <strong>{{ formatIDR(totalExtraChargePrice) }}</strong>
            </p>
          </div>
        </BForm>
      </BTab>
      <BTab title="Payment">
        <div class="form-group">
          <BFormSelect v-model="reservationForm.payment_method_uuid" class="">
            <template #first>
              <BFormSelectOption :value="null" disabled>
                Select payment method
              </BFormSelectOption>
            </template>
            <BFormSelectOption
              v-for="method in paymentMethods"
              :key="method.uuid"
              :value="method.uuid"
            >
              {{ method.name }} {{ method.number }}
            </BFormSelectOption>
          </BFormSelect>
        </div>
        <div class="form-group">
          <BFormRadioGroup
            v-model="reservationForm.payment_status"
            :options="paymentStatus"
            text-field="text"
            value-field="text"
            @change="handleSelectedPaymentStatus($event.target.value)"
          />
        </div>
        <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
          <label for="">Room Price</label>
          <BFormInput
            type="number"
            v-model.number="reservationForm.room_price"
            @input="isRoomBillEdited = true"
            placeholder="0"
          />
        </div>

        <!-- Total harga otomatis -->
        <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
          <label for="">Total Room Bill</label>
          <BFormInput
            type="number"
            :value="totalPriceBeforeDiscount"
            readonly
            placeholder="0"
          />
        </div>

        <BRow v-show="reservationForm.payment_status == 'DP'">
          <BCol>
            <div class="form-group">
              <label for="">Discount for Room (optional)</label>
              <BFormInput
                type="number"
                v-model="reservationForm.discount"
                placeholder="% / nominal "
              >
              </BFormInput>
            </div>
          </BCol>
          <BCol>
            <div class="form-group">
              <label for="">Discount Value</label>
              <BFormInput
                type="number"
                :value="discountAmount"
                placeholder="0"
                disabled
              >
              </BFormInput>
            </div>
          </BCol>
        </BRow>

        <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
          <label for="">Grand Total</label>
          <BFormInput
            type="number"
            v-model="reservationForm.grand_total"
            :value="grandTotal"
            placeholder="0"
          >
          </BFormInput>
        </div>
        <!-- <div class="form-group">
          <label>
            <input type="checkbox" v-model="autoCalculate" />
            Re-calculate
          </label>
        </div> -->

        <div class="form-group" v-show="reservationForm.payment_status == 'DP'">
          <label for="">Input Pre Payment</label>
          <BFormInput
            type="number"
            v-model="reservationForm.pre_payment" v-if="reservationForm"
            placeholder="Masukkan nominal"
          >
          </BFormInput>
        </div>

        <!-- <div class="form-group">
          <label for="">Tes Format Currency</label>
          <CurrencyInput
            v-model="reservationForm.pre_payment"
            placeholder="Masukkan nominal"
            :options="optionsCurrency"
          />
        </div> -->

        <div
          class="form-group"
          v-show="reservationForm.payment_status == 'Full Payment'"
        >
          <label for="">Room Bill</label>
          <BFormInput
            type="number"
            v-model.number="reservationForm.room_price"
            @input="isRoomBillEdited = true"
            placeholder="0"
          />
        </div>
        <!-- Total harga otomatis -->
        <div class="form-group" v-show="reservationForm.payment_status == 'Full Payment'">
          <label for="">Total Room Bill</label>
          <BFormInput
            type="number"
            :value="totalPriceBeforeDiscount"
            readonly
            placeholder="0"
          />
        </div>
        <BRow v-show="reservationForm.payment_status == 'Full Payment'">
          <BCol>
            <div class="form-group">
              <label for="">Discount for Room(optional)</label>
              <BFormInput
                type="number"
                v-model="reservationForm.discount"
                placeholder="% / nominal "
              >
              </BFormInput>
            </div>
          </BCol>
          <BCol>
            <div class="form-group">
              <label for="">Discount Value</label>
              <BFormInput
                type="number"
                :value="discountAmount"
                placeholder="0"
                disabled
              >
              </BFormInput>
            </div>
          </BCol>
        </BRow>
        <div
          class="form-group"
          v-show="reservationForm.payment_status == 'Full Payment'"
        >
          <label for="">Grand Total</label>
          <BFormInput
            type="number"
            v-model="reservationForm.grand_total"
            :value="grandTotal"
            placeholder="0"
          >
          </BFormInput>
        </div>
        <div class="form-group">
          <label for="">Payment Date</label>
          <BFormInput type="date" v-model="reservationForm.payment_date">
          </BFormInput>
        </div>

        <div class="form-group">
          <BFormTextarea
            v-model="reservationForm.description"
            placeholder="Remarks(optional)"
            rows="3"
          />
        </div>
      </BTab>
    </BTabs>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="handleAction"
          class="mr-2"
          :disabled="isLoading"
        >
          {{
            isLoading
              ? "Loading..."
              : reservationData && reservationData.uuid
              ? "Update"
              : "Save"
          }}
        </BButton>
        <BButton variant="danger" @click="closeModal">Cancel</BButton>
        <!-- <BButton variant="info" @click="testEc">tes EC</BButton> -->
      </div>
    </template>
  </BModal>

  <BModal
    :model-value="modalReschedule"
    scrollable
    centered
    no-close-on-backdrop
    title="Reservation Reschedule"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="mb-0 title">Reschedule Form</h5>
        <!-- <div class="d-flex gap-2 align-items-center">
          <span class="date">17/02/2025 16:00:00</span>
          <span
            class="bg-success rounded-circle bar-status"
            style="width: 10px; height: 10px"
          ></span>
          <span class="info-status">online: <span>Ruth</span></span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="closeModal">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <!-- <BTabs content-class="mt-3" align="center" justified> -->

    <BForm>
      <div class="form-group position-relative">
        <BFormInput
          v-model="searchQuery"
          @focus="isTyped = true"
          @blur="handleBlur"
          placeholder="Search guest name"
          autocomplete="off"
        >
        </BFormInput>

        <BListGroup
          v-if="
            searchQuery.length > 0 && filteredGuestItems.length > 0 && isTyped
          "
          class="position-absolute w-100 border rounded-lg"
          style="z-index: 10; cursor: pointer"
        >
          <BListGroupItem
            v-for="(guest, index) in filteredGuestItems"
            :key="index"
            @mousedown.prevent="selectGuest(guest)"
            :value="guest.uuid"
            v-model="reservationForm.guest_uuid"
            class="p-2 border-0"
            >{{ guest.fullname }}</BListGroupItem
          >
        </BListGroup>
        <span
          v-if="searchQuery.length && filteredGuestItems === 0"
          class="text-muted mt-2"
        >
          Guest not found <router-link to="/guest">Add guest</router-link>
        </span>
      </div>
      <BRow>
        <BCol>
          <div class="form-group">
            <label for="">Check-in Date</label>
            <BFormInput type="date" v-model="reservationForm.start">
            </BFormInput>
          </div>
        </BCol>
        <BCol>
          <div class="form-group">
            <label for="">Check-out Date</label>
            <BFormInput type="date" v-model="reservationForm.end"> </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <BFormSelect
          v-model="selectedRoomCategory"
          :options="roomCategories"
          text-field="name"
          value-field="name"
          class=""
          :disabled="!reservationForm.start || !reservationForm.end"
        >
          <template #first>
            <BFormSelectOption :value="null" disabled
              >Select Type Room</BFormSelectOption
            >
          </template>
        </BFormSelect>
      </div>
      <div v-if="selectedRoomCategory" class="form-group">
        <BFormSelect
          v-model="reservationForm.room_uuid"
          :options="filteredRoomItems"
          text-field="code"
          value-field="uuid"
          @change="handleSelectedRoom($event.target.value)"
          class=""
          :disabled="!reservationForm.start || !reservationForm.end"
        >
          <template #first>
            <BFormSelectOption :value="null" disabled>
              Select Room Number
            </BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
    </BForm>

    <!-- </BTabs> -->
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="handleAction"
          class="mr-2"
          :disabled="isLoading"
        >
          {{
            isLoading
              ? "Loading..."
              : reservationData && reservationData.uuid
              ? "Update"
              : "Save"
          }}
        </BButton>
        <BButton variant="danger" @click="closeModal">Cancel</BButton>
        <!-- <BButton variant="info" @click="testEc">tes EC</BButton> -->
      </div>
    </template>
  </BModal>

  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>
<script>
import { ref, computed, watch, nextTick, onMounted, inject } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";
import {
  BModal,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BForm,
  BRow,
  BCol,
  BTabs,
  BTab,
  BFormRadioGroup,
  BInputGroup,
  BListGroup,
  BListGroupItem,
  BButton,
  BFormTextarea,
} from "bootstrap-vue-next";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { formatIDR } from "@/utils/currency";
import { useRoomPrice } from "@/composable/useRoomPrice";
import CurrencyInput from "vue-currency-input";
import { watchEffect } from "vue";

export default {
  name: "ReservationForm",
  components: {
    BModal,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BForm,
    BRow,
    BCol,
    BTabs,
    BTab,
    BFormTextarea,
    BInputGroup,
    BListGroup,
    BListGroupItem,
    BFormRadioGroup,
    ToastResponse,
    //CurrencyInput,
  },
  props: {
    modal: Boolean,
    modalReschedule: Boolean,
    reservationData: Object,
  },
  emits: [
    "update:modal",
    "update:modalReschedule",
    "update:reservationData",
    "addOrUpdate",
  ],

  setup(props, { emit }) {
    const repositories = inject("repositories");
    const guestRepository = repositories ? repositories.guests : null;
    const extraChargeCategoryRepository = repositories
      ? repositories.extraChargeCategory
      : null;
    const extraChargeRepository = repositories
      ? repositories.extraCharges
      : null;
    const paymentMethodRepository = repositories
      ? repositories.paymentMethod
      : null;
    const roomCategoryRepository = repositories
      ? repositories.roomCategory
      : null;
    const roomRepository = repositories ? repositories.rooms : null;
    const reservationRepository = repositories
      ? repositories.reservations
      : null;
    const sourceRepository = repositories ? repositories.source : null;

    const isLoading = ref(false);

    const paymentStatus = ref([
      { text: "DP", value: "DP" },
      { text: "Full Payment", value: "Full Payment" },
    ]);
    const selectedPaymentMethod = ref(null);

    const roomCategories = ref([]);
    const selectedRoomCategory = ref(null);
    const rooms = ref([]);
    const selectedRoom = ref(null);
    const guests = ref([]);
    const filteredGuestItems = ref([]);
    const sources = ref([]);
    const selectedSourceType = ref(null);
    const selectedSourceItem = ref(null);
    const extraChargeItems = ref([
      {
        selectedExtraChargeUuid: null,
        selectedExtraChargeCategory: null,
        extracharges: [],
        quantity: 1,
        price: 0,
      },
    ]);
    const extracharges = ref([]);
    const extraChargeCategories = ref([]);
    const selectedExtraChargeCategory = ref(null);
    const selectedExtraChargeItem = ref(null);
    const paymentMethods = ref([]);
    const searchQuery = ref("");
    const isTyped = ref(false);
    const extracharge = ref({});
    const roomItem = ref({
      price: 0,
    });
    //--tambah auto calculate
    //const autoCalculate = ref(false)

    //**tambahan untuk update harga room price */
    const isEditMode = ref(false);
    const isFormInitializing = ref(false);

    const initialCombination = ref({
      room_uuid: null,
      source_uuid: null,
      start: null,
      end: null
    });

    const hasUserChangedPriceFields = ref(false);

    const filteredSourceItems = computed(() => {
      //**versi lama */
      if (selectedSourceType.value === "booking_online") {
        return sources.value.filter((item) => item.type === "booking_online");
      } else if (selectedSourceType.value === "agent") {
        return sources.value.filter((item) => item.type === "agent");
      }

      return []; // Return an empty array if no valid type is selected
    });

    const defaultReservationForm = {
      uuid: null,
      extra_charges: [],
      payment_method_uuid: null,
      room_uuid: null,
      guest_uuid: null,
      start: "",
      end: "",
      days: 0,
      discount: 0,
      discount_amount: null,
      grand_total: null,
      description: "",
      payment_status: "DP",
      payment_date: null,
      pre_payment: 0,
      room_category: "",
      //source_uuid: null,
      source_type: null,
      source_detail: null,
      source_name: "",
      guest_fullname: "",
      booking_number: "",
      room_price: 0,
      is_high_season: false,
    };

    const reservationForm = ref({ ...defaultReservationForm });

    //membuat input form currency
    const optionsCurrency = {
      currency: "IDR",
      locale: "id-ID",
      distractionFree: false, // true jika ingin format hilang saat fokus
      precision: 0,
    };

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    let echo = null;
    const initEcho = () => {
      window.Pusher = Pusher;
      echo = new Echo({
        broadcaster: "reverb",
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT,
        forceTLS: false,
        disableStats: true,
      });

      echo
        .channel("reservations")
        .listen("ReservationCreated", (event) => {
          reservationForm.value.push(event.reservation);
        })
        .listen("ReservationUpdated", (event) => {
          const index = reservationForm.value.findIndex(
            (r) => r.uuid === event.reservation.uuid
          );
          if (index !== -1) {
            reservationForm.value[index] = event.reservation;
          }
        })
        .listen("ReservationDeleted", (event) => {
          reservationForm.value = reservationForm.value.filter(
            (r) => r.uuid !== event.reservation.uuid
          );
        });
    };

    const getListGuest = async (params) => {
      await guestRepository
        .getAll(params)
        .then((res) => {
          guests.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    // *codingan baru ronaldi*
    // fungsi cari guest
    const searchGuests = async (keyword) => {
      if (!keyword || keyword.length < 2) {
        filteredGuestItems.value = [];
        return;
      }
      try {
        const res = await guestRepository.search({ keyword });
        filteredGuestItems.value = res.data.data;
      } catch (err) {
        console.error("Search guest error:", err);
        filteredGuestItems.value = [];
      }
    };

    // trigger otomatis setiap kali searchQuery berubah
    watch(searchQuery, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        isTyped.value = true; // setiap kali ada ketikan baru, buka dropdown lagi
        searchGuests(newVal);
      }
    });

    const getListRoomType = (params) => {
      roomCategoryRepository
        .getAll(params)
        .then((res) => {
          roomCategories.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListRoom = (category) => {
      // Kurangi 1 hari dari tanggal end untuk logika availability
      // const startDate = new Date(reservationForm.value.start);
      // startDate.setDate(startDate.getDate() - 1);

      const params = {
        category: category,
        start: reservationForm.value.start,
        //start: startDate.toISOString().split('T')[0], // format YYYY-MM-DD
        end: reservationForm.value.end,
        //end: endDate.toISOString().split('T')[0], // format YYYY-MM-DD
      };

      if (reservationForm.value.uuid) {
        params.reservation_uuid = reservationForm.value.uuid;
      }

      roomRepository
        .getAll(params)
        .then((res) => {
          rooms.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListSource = (params) => {
      sourceRepository
        .getAll(params)
        .then((res) => {
          sources.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListExtraChargeCategory = (params) => {
      extraChargeCategoryRepository
        .getAll(params)
        .then((res) => {
          extraChargeCategories.value = [...res.data.data];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListExtraCharge = (selectedExtraChargeCategory, index) => {
      extraChargeRepository
        .getAll({ extra_charge_category_uuid: selectedExtraChargeCategory })
        .then((res) => {
          if (selectedExtraChargeCategory.length) {
            extraChargeItems.value[index].extracharges = [...res.data.data];
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getListPaymentMethod = () => {
      paymentMethodRepository
        .getAll()
        .then((res) => {
          paymentMethods.value = [
            ...res.data.data.filter((i) => (i.status === "active" ? i : null)),
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    // // *versi lama: madhan*
    // const create = () => {
    //   isLoading.value = true;
    //   reservationForm.value = {
    //     ...reservationForm.value,
    //     grand_total: grandTotal.value,
    //     discount_amount: discountAmount.value,
    //     days: calculateDays.value,
    //     status: "booked",
    //     discount: reservationForm.value.discount || 0,
    //     is_high_season: isHighSeason.value ? 1 : 0,
    //     extra_charges: extraChargeItems.value
    //       .filter((item) => item.selectedExtraChargeUuid !== null)
    //       .map((item) => ({
    //         uuid: item.selectedExtraChargeUuid,
    //         quantity: item.quantity,
    //         price: item.extracharges[0]?.price,
    //       })),
    //   };

    //   reservationRepository
    //     .create(reservationForm.value)
    //     .then(() => {
    //       updateModal(false);
    //       Object.assign(reservationForm.value, {});
    //       searchQuery.value = "";
    //       selectedRoomCategory.value = null;
    //       selectedSourceType.value = null;
    //       Object.assign(modalResponse.value, {
    //         success: true,
    //         text: "Reservation created successfully",
    //         toast: true,
    //       });
    //       emit("addOrUpdate");
    //     })
    //     .catch((err) => {
    //       Object.assign(modalResponse.value, {
    //         success: false,
    //         text: err.response.data.message,
    //         toast: true,
    //       });
    //     })
    //     .finally(() => {
    //       isLoading.value = false;
    //     });
    // };

    //* versi baru: naldi */
    const create = () => {
      try {
        isLoading.value = true;

        // simpan dulu nilai yg dibutuhkan sebelum assign
        const currentDiscount = reservationForm.value.discount || 0;

        // Object.assign(reservationForm.value, {
        //   grand_total: grandTotal.value,
        //   discount_amount: discountAmount.value,
        //   days: calculateDays.value,
        //   status: "booked",
        //   discount: currentDiscount,
        //   //is_high_season: isHighSeason.value ? 1 : 0,
        //   is_high_season: roomPriceDetails.value?.isHighSeason ? 1 : 0,
        //   extra_charges: extraChargeItems.value
        //     .filter((item) => item.selectedExtraChargeUuid !== null)
        //     .map((item) => ({
        //       uuid: item.selectedExtraChargeUuid,
        //       quantity: item.quantity,
        //       price: item.extracharges[0]?.price,
        //     })),
        // });

        //**codingan versi madhan versi refactor*/
        const payload = {
          ...reservationForm.value,
          grand_total:
            grandTotal?.value ?? reservationForm.value?.grand_total ?? 0,
          discount_amount: discountAmount?.value ?? 0,
          days: calculateDays?.value ?? 0,
          status: "booked",
          discount: currentDiscount,
          is_high_season: roomPriceDetails?.value?.isHighSeason ? 1 : 0,
          extra_charges: (extraChargeItems?.value || [])
            .filter((item) => item?.selectedExtraChargeUuid != null && item?.quantity > 0)
            .map((item) => {
              return {
                uuid: item.selectedExtraChargeUuid,
                quantity: item.quantity ?? 1,
                price: Number(item.price) || 0,
              };
            }),
        };

        reservationRepository
          .create(payload)
          .then(() => {
            //updateModal(false);
            emit("update:modal", false);

            // reset isi form tanpa kehilangan struktur reactive
            // Object.assign(reservationForm.value, {
            //   uuid: null,
            //   extra_charges: [],
            //   payment_method_uuid: null,
            //   room_uuid: null,
            //   source_uuid: null,
            //   guest_uuid: null,
            //   start: "",
            //   end: "",
            //   days: 0,
            //   discount: 0,
            //   discount_amount: null,
            //   grand_total: null,
            //   description: "",
            //   payment_status: "DP",
            //   payment_date: null,
            //   pre_payment: 0,
            //   room_category: "",
            //   source_name: "",
            //   guest_fullname: "",
            //   booking_number: "",
            //   room_price: 0,
            //   is_high_season: false,
            // });

            // Object.assign(reservationForm.value, {});
            // ✅ langsung reset full form
            //reservationForm.value = { ...defaultReservationForm };
            Object.assign(reservationForm.value, { ...defaultReservationForm })


            searchQuery.value = "";
            selectedRoomCategory.value = null;
            selectedSourceType.value = null;
            selectedSourceItem.value = null;

            Object.assign(modalResponse.value, {
              success: true,
              text: "Reservation created successfully",
              toast: true,
            });

            emit("addOrUpdate");
          })
          .catch((err) => {
            Object.assign(modalResponse.value, {
              success: false,
              text:
                err.response?.data?.message || "Failed to create reservation",
              toast: true,
            });
            console.error("❌ API create error:", err);
          })
          .finally(() => {
            isLoading.value = false;
          });
      } catch (err) {
        console.error("Create reservation failed:", err);
        isLoading.value = false;
      }
    };

    // //**codingan lama : madhan */
    // const update = () => {
    //   isLoading.value = true;
    //   reservationForm.value = {
    //     ...reservationForm.value,
    //     grand_total: grandTotal.value,
    //     discount_amount: discountAmount.value,
    //     days: calculateDays.value,
    //     discount: reservationForm.value.discount || 0,
    //     is_high_season: isHighSeason.value ? 1 : 0,
    //     extra_charges: extraChargeItems.value
    //       .filter((item) => item.selectedExtraChargeUuid !== null)
    //       .map((item) => ({
    //         uuid: item.selectedExtraChargeUuid,
    //         quantity: item.quantity,
    //         price: item.extracharges[0]?.price,
    //       })),
    //   };


    //   reservationRepository
    //     .update(reservationForm.value.uuid, reservationForm.value)
    //     .then(() => {
    //       updateModal(false);
    //       Object.assign(reservationForm.value, {});
    //       searchQuery.value = "";
    //       selectedRoomCategory.value = null;
    //       selectedSourceType.value = null;
    //       Object.assign(modalResponse.value, {
    //         success: true,
    //         text: "Reservation updated successfully",
    //         toast: true,
    //       });
    //       emit("addOrUpdate");
    //     })
    //     .catch((err) => {
    //       Object.assign(modalResponse.value, {
    //         success: false,
    //         text: err.response.data.message,
    //         toast: true,
    //       });
    //     })
    //     .finally(() => {
    //       isLoading.value = false;
    //     });
    // };

    //**codingan baru : naldi */
    const update = () => {
      try {
        isLoading.value = true;
        console.log(
          "Form data sebelum di-update:",
          JSON.stringify(reservationForm.value, null, 2)
        );

        // simpan dulu nilai yg dibutuhkan sebelum assign
        //const currentDiscount = reservationForm.value.discount || 0;

        const payload = {
          ...reservationForm.value,
          grand_total:
            grandTotal?.value ?? reservationForm.value?.grand_total ?? 0,
          discount_amount: discountAmount?.value ?? 0,
          days: calculateDays?.value ?? 0,
          discount: reservationForm.value.discount || 0,
          is_high_season: roomPriceDetails.value?.isHighSeason ? 1 : 0,
          extra_charges: extraChargeItems.value
            .filter((item) => item.selectedExtraChargeUuid !== null && item.quantity > 0)
            .map((item) => {
              return {
                uuid: item.selectedExtraChargeUuid,
                quantity: item.quantity ?? 1,
                price: Number(item.price) || 0,
              };
            }),
        };
        console.log(
          "Payload yg dikirim ke API:",
          JSON.stringify(payload, null, 2)
        );

        reservationRepository
          .update(reservationForm.value.uuid, payload)
          .then(() => {
            updateModal(false);

            // Object.assign(reservationForm.value, {});
            Object.assign(reservationForm.value, { ...defaultReservationForm })
            searchQuery.value = "";
            selectedRoomCategory.value = null;
            selectedSourceType.value = null;
            selectedSourceItem.value = null;

            Object.assign(modalResponse.value, {
              success: true,
              text: "Reservation updated successfully",
              toast: true,
            });

            emit("addOrUpdate");
          })
          .catch((err) => {
            Object.assign(modalResponse.value, {
              success: false,
              text: err.response.data.message || "Failed to update reservation",
              toast: true,
            });
            console.error("❌ API update error:", err);
          })
          .finally(() => {
            isLoading.value = false;
          });
      } catch (err) {
        console.error("Update reservation failed:", err);
        isLoading.value = false;
      }
    };

    const addItemExtraCharge = () => {
      extraChargeItems.value.push({
        selectedExtraChargeUuid: null,
        selectedExtraChargeCategory: null,
        extracharges: [],
        quantity: 1,
        price: 0,
      });
    };
    const deleteItemExtracharge = () => {
      if (extraChargeItems.value.length > 1) {
        extraChargeItems.value.pop();
      } else {
        extraChargeItems.value = [
          {
            selectedExtraChargeUuid: null,
            selectedExtraChargeCategory: null,
            extracharges: [],
            quantity: 1,
            price: 0,
          },
        ];
      }
    };
    const increaseQuantity = (index) => {
      extraChargeItems.value[index].quantity++;
    };
    const decreaseQuantity = (index) => {
      if (extraChargeItems.value[index].quantity > 0) {
        extraChargeItems.value[index].quantity--;
      }
    };
    const handleSelectedPaymentStatus = (event) => {
      reservationForm.value.payment_status = event;
    };
    const handleBlur = () => {
      setTimeout(() => {
        isTyped.value = false;
      }, 150);
    };
    const handleSelectedRoom = (event) => {
      const selectedRoom = rooms.value.find((room) => room.uuid === event);
      return selectedRoom;
    };

    const closeModal = () => {
      updateModal(false);
      searchQuery.value = "";
      selectedRoomCategory.value = null;
      selectedSourceType.value = null;
    };
    const updateModal = (value) => {
      Object.assign(reservationForm.value, { ...defaultReservationForm });
      emit("update:modal", value); // Sync modal state with parent
      emit("update:modalReschedule", value);
    };
    const selectGuest = (guest) => {
      reservationForm.value.guest_uuid = guest.uuid;
      searchQuery.value = guest.fullname;
      nextTick(() => {
        filteredGuestItems.value = [];
      });
      isTyped.value = false;

      //isTyped.value = true;
    };

    const totalExtraChargePrice = computed(() => {
      return extraChargeItems.value.reduce((sum, ext) => {
        const price = Number(ext.price) || 0;
        const qty = Number(ext.quantity) || 0;
        return sum + price * qty;
      }, 0);
    });

    // const isHighSeason = computed(() => {
    //   const startDate = new Date(reservationForm.value.start);
    //   const endDate = new Date(reservationForm.value.end);

    //   return startDate.getMonth() === 5 || endDate.getMonth() === 5; // bulan Juni (0-indexed)
    // });

    // const roomPrice = computed(() => {
    //   const selectedRoom = rooms.value.find(
    //     (room) => room.uuid === reservationForm.value.room_uuid
    //   );

    //   if (!selectedRoom) return 0;

    //   const priceType = isHighSeason.value
    //     ? "high_season_price"
    //     : "low_season_price";
    //   return selectedRoom.room_category[priceType] || 0;
    // });

    // // *codingan lama: naldi*
    // //Telah dibuat jadi Function Composable
    // const { isHighSeason, roomPrice } = useRoomPrice(reservationForm, rooms);

    // baru — tambahkan computed wrapper untuk source_uuid dan ambil roomPriceDetails
    // const sourceUuidRef = computed(() =>
    //   reservationForm && reservationForm.value ? reservationForm.value.source_uuid : null
    // );

    // // ini yang benar
    // const sourceUuidRef = computed(() => reservationForm.value.source_uuid)

    //ganti
    const sourceTypeRef = computed(() => reservationForm.value.source_type);

    // const { isHighSeason, roomPrice, roomPriceDetails } = useRoomPrice(
    //   reservationForm,
    //   rooms,
    //   sourceUuidRef
    // )

    //ganti
    const { isHighSeason, roomPrice, roomPriceDetails } = useRoomPrice(
      reservationForm,
      rooms,
      sourceTypeRef
    );

    // // *codingan lama: madhan*
    // const calculateDays = computed(() => {
    //   if (reservationForm.value.start && reservationForm.value.end) {
    //     const startDate = new Date(reservationForm.value.start);
    //     const endDate = new Date(reservationForm.value.end);

    //     const timeDifference = endDate.getTime() - startDate.getTime();

    //     const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
    //     return daysDifference;
    //   }
    //   return 0;
    // });

    // *codingan baru: naldi*
    const calculateDays = computed(() => {
      if (!reservationForm.value.start || !reservationForm.value.end) return 0;
      const start = new Date(reservationForm.value.start);
      const end = new Date(reservationForm.value.end);
      const diffTime = end - start;
      return diffTime > 0 ? diffTime / (1000 * 60 * 60 * 24) : 0;
    });

    watch(
      () => calculateDays.value,
      (newDays, oldDays) => {
        // 🔒 abaikan jika belum ada tanggal lengkap
        if (
          !reservationForm.value.start ||
          !reservationForm.value.end ||
          isNaN(newDays)
        )
          return;

        // 🔒 abaikan jika nilai tidak berubah
        if (newDays === oldDays) return;

        const price = Number(reservationForm.value.room_price) || 0;
        if (price <= 0) return; // harga belum ada → gak usah hitung total

        if (!totalPriceBeforeDiscount.value) {
          totalPriceBeforeDiscount.value = price * Math.max(1, newDays);
          reservationForm.value.grand_total =
            totalPriceBeforeDiscount.value -
            (reservationForm.value.discount_amount || 0);

          console.log("[Recalculate total on calculateDays change]", {
            newDays,
            total: totalPriceBeforeDiscount.value,
          });
        }
      }
    );

    const isRoomBillEdited = ref(false);

    // // ** variabel lama */
    // const totalPriceBeforeDiscount = ref(0);

    const totalPriceBeforeDiscount = computed(() => {
      const price = Number(reservationForm.value.room_price) || 0;
      const nights = Math.max(1, Number(calculateDays.value) || 1);
      return price * nights;
    });

    // baru: roomPrice.value adalah TOTAL selama stay
    watchEffect(() => {
      //**tambahan coding baru */
      // Jika sedang edit, jangan override harga manual
      if (isFormInitializing?.value) 
        return;

      if (isEditMode.value && !hasUserChangedPriceFields.value) 
        return;

      if (!isRoomBillEdited.value) {
        const total = roomPrice.value || 0;
        totalPriceBeforeDiscount.value = total;

        // reservationForm.room_price harus menyimpan harga PER MALAM
        const perNight =
          (roomPriceDetails &&
            roomPriceDetails.value &&
            roomPriceDetails.value.averagePerNight) ||
          (calculateDays.value ? total / calculateDays.value : 0);

        reservationForm.value.room_price = perNight || 0;
      }
    });

    // watchEffect(() => {
    //   console.log("Source Type:", reservationForm.value.source_type);
    //   console.log(
    //     "Dates:",
    //     reservationForm.value.start,
    //     reservationForm.value.end
    //   );
    //   const selectedRoom = rooms.value.find(
    //     (r) => r.uuid === reservationForm.value.room_uuid
    //   );
    //   console.log("Room Category Prices:", selectedRoom?.room_category?.prices);
    //   console.log("roomPrice:", roomPrice.value);
    // });

    watch(
      [
        () => reservationForm.value.room_uuid,
        () => reservationForm.value.start,
        () => reservationForm.value.end,
        () => reservationForm.value.source_type,
      ],
      (
        [newRoom, newStart, newEnd, newSourceType],
        [oldRoom, oldStart, oldEnd, oldSourceType]
      ) => {
        if (
          newRoom !== oldRoom ||
          newStart !== oldStart ||
          newEnd !== oldEnd ||
          newSourceType !== oldSourceType
        ) {
          isRoomBillEdited.value = false;
        }
      }
    );

    // Sinkronisasi: kalau dropdown source_type berubah, update ke reservationForm
    watch(selectedSourceType, (val) => {
      console.log("Selected Source Type:", reservationForm.value);
      reservationForm.value.source_type = val;
    });

    // Auto-assign source_uuid sesuai kondisi
    watch([selectedSourceType, filteredSourceItems], ([type, items]) => {
      if (isFormInitializing.value) return;

      if (!type) {
        reservationForm.value.source_uuid = null;
        return;
      }

      if (["walk_in", "direct_booking"].includes(type)) {
        // Walk-in & Direct Booking: langsung pilih source yang sesuai type
        const source = sources.value.find((s) => s.type === type);
        reservationForm.value.source_uuid = source ? source.uuid : null;
      } else if (items.length === 1) {
        // Booking Online & Agent: kalau hasil filter hanya 1 item → auto pilih
        reservationForm.value.source_uuid = items[0].uuid;
      } else if (items.length > 1) {
        // Kalau ada banyak pilihan (contoh banyak agent/online travel)
        // Cek dulu apakah yang sekarang masih valid di dalam item list baru
        const isStillValid = items.some(
          (item) => item.uuid === reservationForm.value.source_uuid
        );
        if (!isStillValid) {
          reservationForm.value.source_uuid = null;
        }
      }
    });

    watch(totalPriceBeforeDiscount, (val, oldVal) => {
      if (val !== oldVal) {
        // Kalau berubah dan user memang edit (tangkap perubahan manual)
        if (!isRoomBillEdited.value) {
          isRoomBillEdited.value = true;
        }
        reservationForm.value.room_price = val / calculateDays.value || 0;
      }
    });

    const discountAmount = computed(() => {
      if (reservationForm.value.discount) {
        if (reservationForm.value.discount.toString().length <= 3) {
          return (
            totalPriceBeforeDiscount.value *
            (parseFloat(reservationForm.value.discount) / 100)
          );
        } else {
          return parseFloat(reservationForm.value.discount);
        }
      }
      return 0;
    });

    const grandTotal = computed(() => {
      return (
        totalPriceBeforeDiscount.value +
        totalExtraChargePrice.value -
        discountAmount.value
      );
    });

    const handleExtraChargeCategory = (category, index) => {
      console.log("category", category);
      extraChargeItems.value[index].extra_charge_uuid = null; // Reset item when category changes
      extraChargeItems.value[index].selectedExtraChargeUuid = null;
      extraChargeItems.value[index].price = 0;
      getListExtraCharge(category, index); // Fetch charges based on selected category
    };
    const handleExtraCharge = (uuid, index) => {
      extraChargeItems.value[index].selectedExtraChargeUuid = uuid;
      if (extraChargeItems.value[index].quantity === 0) {
        extraChargeItems.value[index].quantity = 1;
      }
      const selected = extraChargeItems.value[index].extracharges.find(
        (item) => item.uuid === uuid
      );
      if (selected) {
        extraChargeItems.value[index].price = Number(selected.price) || 0;
      }

      if (!Array.isArray(reservationForm.value.extra_charges)) {
        reservationForm.value.extra_charges = [];
      }
      // Ensure we only add unique UUIDs
      // if (!reservationForm.value.extra_charges.includes(uuid)) {
      //   reservationForm.value.extra_charges.push(uuid);
      // }
    };

    const sourceTypes = computed(() => {
      const sourceFormat = {
        booking_online: "Booking Online",
        walk_in: "Walk In",
        direct_booking: "Direct Booking",
        agent: "Agent",
      };
      const types = new Set();
      return sources.value
        .filter((item) => {
          if (!types.has(item.type)) {
            types.add(item.type);
            return true;
          }
          return false;
        })
        .map((item) => ({
          type: item.type,
          name:
            sourceFormat[item.type] ||
            item.type.charAt(0).toUpperCase() + item.type.slice(1), // Capitalize for display
        }));
    });

    const handleAction = () => {
      if (isRoomBillEdited.value) {
        reservationForm.value.room_price =
          totalPriceBeforeDiscount.value / calculateDays.value || 0;
      }
      // props.reservationData.uuid ? update() : create();

      // gunakan optional chaining agar tidak error saat props masih null/{}.
      if (props.reservationData?.uuid) {
        update();
      } else {
        create();
      }

    };

    watch(isHighSeason, (value) => {
      // reservationForm.value.is_high_season = value;
      reservationForm.value.is_high_season = value;
    });

    // // *codingan lama: naldi*
    // watch(roomPrice, (value) => {
    //   if (!isRoomBillEdited.value) {
    watch(roomPrice, (value) => {
      // // **format lama*
      // if (!isRoomBillEdited.value) {
      //   const perNight =
      //     roomPriceDetails?.value?.averagePerNight ??
      //     (calculateDays.value ? value / calculateDays.value : 0);
      //   reservationForm.value.room_price = perNight || 0;
      // }
      if (isFormInitializing?.value) return; // kalau kamu pakai flag ini

      if (isEditMode.value && !hasUserChangedPriceFields.value) return; // blok saat edit

      // Jika sedang edit, jangan override harga manual
      if (!isRoomBillEdited.value) {
        const perNight =
          roomPriceDetails?.value?.averagePerNight ??
          (calculateDays.value ? value / calculateDays.value : 0);
        reservationForm.value.room_price = perNight || 0;

        reservationForm.value.totalPriceBeforeDiscount =
          totalPriceBeforeDiscount.value;
        reservationForm.value.discount_amount = discountAmount.value;
        reservationForm.value.grand_total = grandTotal.value;
      }
    });

    watch(searchQuery, (newQuery) => {
      if (!newQuery && isTyped.value) {
        filteredGuestItems.value = [];
      } else {
        filteredGuestItems.value = guests.value.filter((guest) => {
          return guest.fullname.toLowerCase().includes(newQuery.toLowerCase());
        });
      }
    });

    const filteredRoomItems = computed(() => {
      return rooms.value.filter(
        (room) => room.room_category.name === selectedRoomCategory.value
      );
    });

    watch(selectedRoomCategory, (newCategory) => {
      if (newCategory) {
        getListRoom(newCategory);
      }
    });

    watch(
      [() => reservationForm.value.start, () => reservationForm.value.end],
      ([newStart, newEnd]) => {
        if (newStart && newEnd) {
          getListRoom(selectedRoomCategory.value);
        }
      }
    );

    watch(
      () => reservationForm.value.payment_status,
      (newStatus) => {
        if (!reservationForm.value || !newStatus) return; // data belum siap

        //if (autoCalculate.value) {
        reservationForm.value.discount_amount = discountAmount.value ?? 0;
        reservationForm.value.totalPriceBeforeDiscount = totalPriceBeforeDiscount.value ?? 0;
        reservationForm.value.grand_total = grandTotal.value ?? 0;

        //*codingan lama: madhan*
        if (newStatus === "DP") {
          reservationForm.value.pre_payment =
            props.reservationData?.pre_payment ?? 0;
        }
        if (newStatus === "Full Payment") {
          // Full Payment → tidak ada DP, pre_payment harus 0
          reservationForm.value.pre_payment = 0;
          reservationForm.value.payment_date =
            reservationForm.value.payment_date ||
            new Date().toISOString().split("T")[0];
        }
      },
      { immediate: false }
    );

    watch(
      () => reservationForm.value.pre_payment,
      (newPrePayment) => {
        const currentGrandTotal = grandTotal.value ?? reservationForm.value.grand_total ?? 0;
        if (currentGrandTotal > 0 && Number(newPrePayment) >= Number(currentGrandTotal)) {
          reservationForm.value.payment_status = "Full Payment";
        }
      }
    );


    // // **versi lama: madhan*
    // watch(
    //   () => props.reservationData,
    //   (newData) => {
    //     if (
    //       newData &&
    //       (newData.guest ||
    //         newData.room ||
    //         newData.source ||
    //         newData.payment_method ||
    //         (newData.extracharge && Array.isArray(newData.extracharge)))
    //     ) {
    //       searchQuery.value = newData.guest.fullname;
    //       reservationForm.value.uuid = newData.uuid;
    //       reservationForm.value.guest_uuid = newData.guest.uuid;
    //       selectedRoomCategory.value = newData.room.room_category.name;
    //       reservationForm.value.room_uuid = newData.room.uuid;
    //       selectedSourceType.value = newData.source.type;
    //       reservationForm.value.payment_method_uuid = newData.payment_method.uuid;
    //       reservationForm.value.source_uuid = newData.source.uuid;
    //       reservationForm.value.payment_status = newData.payment_status;
    //       reservationForm.value.payment_date = newData.payment_date;
    //       reservationForm.value.pre_payment = newData.pre_payment;
    //       reservationForm.value.discount = parseInt(newData.discount);
    //       // // *tambahan baru*
    //       // reservationForm.value.room_price = newData.room_price ?? 0;

    //       reservationForm.value.start = newData.start;
    //       reservationForm.value.end = newData.end;
    //       reservationForm.value.number = newData.number;
    //       reservationForm.value.description = newData.description;
    //       reservationForm.value.status = newData.status;
    //       reservationForm.value.booking_number = newData.booking_number;
    //       extraChargeItems.value = [];

    //       // Map extracharges to the required format
    //       newData.extracharge.forEach((ext) => {
    //         extraChargeItems.value.push({
    //           selectedExtraChargeCategory:
    //             ext.extra_charge.extracharge_category.uuid,
    //           selectedExtraChargeUuid: ext.extra_charge.uuid,
    //           extracharges: [
    //             {
    //               name: ext.extra_charge.name,
    //               price: ext.extra_charge.price,
    //               quantity: ext.quantity,
    //               uuid: ext.extra_charge.uuid,
    //             },
    //           ],
    //           quantity: ext.quantity,
    //           price: ext.extra_charge.price,
    //         });
    //       });

    //     } else {
    //       // Reset to default if no extracharges
    //       extraChargeItems.value = [
    //         {
    //           selectedExtraChargeUuid: null,
    //           selectedExtraChargeCategory: null,
    //           extracharges: [],
    //           quantity: 0,
    //           price: 0,
    //         },
    //       ];
    //     }
    //   },
    //   { immediate: true } // This ensures it runs immediately on initial load
    // );

    // // **versi baru: naldi*
    // watch(
    //   () => props.reservationData,
    //   async (newData) => {
    //     if (!newData) return;

    //     if (
    //       newData &&
    //       (newData.guest ||
    //         newData.room ||
    //         newData.source ||
    //         newData.payment_method ||
    //         (newData.extracharge && Array.isArray(newData.extracharge)))
    //     ) {
    //       isFormInitializing.value = true;
    //       // Flag edit mode aktif
    //       isEditMode.value = !!newData.uuid;

    //       // Map tanggal dulu (important supaya calculateDays bisa tercompute)
    //       reservationForm.value.start = newData.start ?? "";
    //       reservationForm.value.end = newData.end ?? "";

    //       searchQuery.value = newData.guest.fullname;
    //       reservationForm.value.uuid = newData.uuid;
    //       reservationForm.value.guest_uuid = newData.guest.uuid;
    //       selectedRoomCategory.value = newData.room.room_category.name;
    //       reservationForm.value.room_uuid = newData.room.uuid;
    //       selectedSourceType.value = newData.source.type;
    //       reservationForm.value.payment_method_uuid =
    //         newData.payment_method.uuid;
    //       reservationForm.value.source_uuid = newData.source.uuid;
    //       reservationForm.value.payment_status = newData.payment_status;
    //       reservationForm.value.payment_date = newData.payment_date;
    //       reservationForm.value.pre_payment = newData.pre_payment;
    //       reservationForm.value.discount = parseInt(newData.discount);
    //       // // *tambahan baru*
    //       // reservationForm.value.room_price = newData.room_price ?? 0;

    //       reservationForm.value.number = newData.number;
    //       reservationForm.value.description = newData.description;
    //       reservationForm.value.status = newData.status;
    //       reservationForm.value.booking_number = newData.booking_number;
    //       extraChargeItems.value = [];

    //       // Simpan kombinasi awal yang mempengaruhi harga (untuk deteksi perubahan nanti)
    //       initialCombination.value = {
    //         room_uuid: newData.room_uuid,
    //         source_uuid: newData.source_uuid,
    //         start: newData.start,
    //         end: newData.end,
    //       };

    //       hasUserChangedPriceFields.value = false;

    //       await nextTick(); // ⏳ pastikan semua reactivity settle dulu
    //       // 💡 Set harga dari tabel reservations (setelah nextTick)
    //       reservationForm.value.room_price = newData.room_price ?? 0;

    //       // if calculateDays.value is 0 (missing dates), fallback ke 1 night
    //       const nights = Number(calculateDays.value) || 1;
    //       totalPriceBeforeDiscount.value =
    //         (reservationForm.value.room_price || 0) * nights;

    //       // Map extracharges to the required format
    //       newData.extracharge.forEach((ext) => {
    //         extraChargeItems.value.push({
    //           selectedExtraChargeCategory:
    //             ext.extra_charge.extracharge_category.uuid,
    //           selectedExtraChargeUuid: ext.extra_charge.uuid,
    //           extracharges: [
    //             {
    //               name: ext.extra_charge.name,
    //               price: ext.extra_charge.price,
    //               quantity: ext.quantity,
    //               uuid: ext.extra_charge.uuid,
    //             },
    //           ],
    //           quantity: ext.quantity,
    //           price: ext.extra_charge.price,
    //         });
    //       });

    //       // Reset manual edit flag
    //       isRoomBillEdited.value = false;

    //       // ✅ Tutup fase inisialisasi
    //       isFormInitializing.value = false;
    //     } else {
    //       // Reset to default if no extracharges
    //       extraChargeItems.value = [
    //         {
    //           selectedExtraChargeUuid: null,
    //           selectedExtraChargeCategory: null,
    //           extracharges: [],
    //           quantity: 0,
    //           price: 0,
    //         },
    //       ];
    //     }
    //   },
    //   { immediate: true } // This ensures it runs immediately on initial load
    // );

    // ✅ Versi stabil final (versi Naldi + patch aman)
    watch(
      () => props.reservationData,
      async (newData) => {
        if (!newData) return;

        if (
          newData &&
          (newData.guest ||
            newData.room ||
            newData.source ||
            newData.payment_method ||
            (newData.extracharge && Array.isArray(newData.extracharge)))
        ) {
          isFormInitializing.value = true;
          isEditMode.value = !!newData.uuid;

          // Pastikan mapping tanggal dulu
          reservationForm.value.start = newData.start ?? "";
          reservationForm.value.end = newData.end ?? "";

          searchQuery.value = newData?.guest?.fullname ?? "";
          reservationForm.value.uuid = newData.uuid ?? null;
          reservationForm.value.guest_uuid = newData?.guest?.uuid ?? null;
          selectedRoomCategory.value = newData?.room?.room_category?.name ?? "";
          reservationForm.value.room_uuid = newData?.room?.uuid ?? null;
          selectedSourceType.value = newData?.source?.type ?? "";
          reservationForm.value.payment_method_uuid =
            newData?.payment_method?.uuid ?? null;
          reservationForm.value.source_uuid = newData?.source?.uuid ?? null;
          console.log("reservationForm.value.source_uuid", reservationForm.value.source_uuid);
          reservationForm.value.payment_status = newData.payment_status ?? "DP";
          reservationForm.value.payment_date = newData.payment_date ?? null;
          reservationForm.value.pre_payment = newData.pre_payment ?? 0;
          reservationForm.value.discount = parseInt(newData.discount ?? 0);
          reservationForm.value.number = newData.number ?? "";
          reservationForm.value.description = newData.description ?? "";
          reservationForm.value.status = newData.status ?? "";
          reservationForm.value.booking_number = newData.booking_number ?? "";
          extraChargeItems.value = [];

          initialCombination.value = {
            room_uuid: newData?.room?.uuid ?? newData.room_uuid ?? null,
            source_uuid: newData?.source?.uuid ?? newData.source_uuid ?? null,
            start: newData.start,
            end: newData.end,
          };

          hasUserChangedPriceFields.value = false;

          await nextTick();

          reservationForm.value.room_price = newData.room_price ?? 0;

          const nights = Number(calculateDays.value) || 1;
          totalPriceBeforeDiscount.value =
            (reservationForm.value.room_price || 0) * nights;

          // ✅ Tambahan aman untuk extracharge
          if (Array.isArray(newData.extracharge) && newData.extracharge.length > 0) {
            extraChargeItems.value = newData.extracharge.map((ext) => ({
              selectedExtraChargeCategory:
                ext.extra_charge?.extracharge_category?.uuid ?? null,
              selectedExtraChargeUuid: ext.extra_charge?.uuid ?? null,
              extracharges: [
                {
                  name: ext.extra_charge?.name ?? "",
                  price: ext.extra_charge?.price ?? 0,
                  quantity: ext.quantity ?? 0,
                  uuid: ext.extra_charge?.uuid ?? null,
                },
              ],
              quantity: ext.quantity ?? 0,
              price: ext.extra_charge?.price ?? 0,
            }));
          } else {
            extraChargeItems.value = [
              {
                selectedExtraChargeUuid: null,
                selectedExtraChargeCategory: null,
                extracharges: [],
                quantity: 1,
                price: 0,
              },
            ];
          }

          isRoomBillEdited.value = false;
          isFormInitializing.value = false;
        }
      },
      { immediate: true, deep: true }
    );




    //watch baru untuk mendeteksi
    // perubahan pada bidang yang memengaruhi harga (kamar, sumber, awal, akhir)
    watch(
      [
        () => reservationForm.value.room_uuid,
        () => reservationForm.value.source_uuid,
        () => reservationForm.value.start,
        () => reservationForm.value.end,
      ],
      ([room, source, start, end]) => {
        if (isFormInitializing.value) return;

        const changed =
          room !== initialCombination.value.room_uuid ||
          source !== initialCombination.value.source_uuid ||
          start !== initialCombination.value.start ||
          end !== initialCombination.value.end;

        if (changed) {
          hasUserChangedPriceFields.value = true;

          // // panggil ulang fungsi kalkulasi harga jika sudah ada
          // if (typeof getRoomPrice === 'function') {
          //   getRoomPrice(true);
          // }
        }
      }
    );

    onMounted(() => {
      getListGuest();
      getListRoomType();
      getListSource();
      getListExtraChargeCategory();
      getListPaymentMethod();
    });

    return {
      isLoading,
      initEcho,
      create,
      updateModal,
      closeModal,
      handleAction,
      handleSelectedPaymentStatus,
      handleExtraChargeCategory,
      handleExtraCharge,
      handleSelectedRoom,
      handleBlur,
      addItemExtraCharge,
      deleteItemExtracharge,
      increaseQuantity,
      decreaseQuantity,
      selectGuest,
      getListGuest,
      getListRoomType,
      getListRoom,
      getListSource,
      getListExtraChargeCategory,
      getListExtraCharge,
      getListPaymentMethod,
      roomCategories,
      rooms,
      roomItem,
      selectedRoomCategory,
      selectedRoom,
      selectedPaymentMethod,
      selectedSourceType,
      selectedSourceItem,
      sources,
      selectedExtraChargeCategory,
      selectedExtraChargeItem,
      extraChargeItems,
      extracharges,
      extraChargeCategories,
      extracharge,
      reservationForm,
      paymentMethods,
      paymentStatus,
      guests,
      filteredGuestItems,
      filteredSourceItems,
      filteredRoomItems,
      roomPrice,
      totalPriceBeforeDiscount,
      totalExtraChargePrice,
      grandTotal,
      discountAmount,
      calculateDays,
      searchQuery,
      isTyped,
      sourceTypes,
      modalResponse,
      formatIDR,
      isHighSeason,
      CurrencyInput,
      optionsCurrency,
      //autoCalculate,
    };
  },
};
</script>

<style>
@media screen and (max-width: 576px) {
  .modal-title .title {
    font-size: 1rem;
  }
  .modal-title .date,
  .modal-title .info-status {
    font-size: 0.675rem;
  }
}
</style>
